import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import {
  search,
  loadData,
  updateData,
  updateCellValue,
} from "ka-table/actionCreators";
import { SortingMode, PagingPosition } from "ka-table/enums";
import stockService from "../services/flstock-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import facilityService from "../services/facility-service";


const tablePropsInit = {
  columns: [
    { key: "drg_name", title: "Drug", style: { width: 180 } },
    { key: "Description", title: "Description", style: { width: 180 } },
    { key: "Actions", title: "Quantity", style: { width: 120 } },
    { key: "category", title: "Category", style: { width: 150 } },
    { key: "LastOrderDate", title: "Last Order Date", style: { width: 130 } },
    { key: "LastOrderQty", title: "Last Order Quantity", style: { width: 130 } },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const tablePropsInit1 = {
  columns: [
    { key: "drg_name", title: "Drug" },
    { key: "Description", title: "Description" },
    { key: "qnty", title: "Quantity" },
    { key: "category", title: "Category" },
    { key: "LastOrderDate", title: "Last Order Date" },
    { key: "LastOrderQty", title: "Last Order Quantity" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const FLStockOrder = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [showDrugList, setShowDrugList] = useState(false);
  const [facList, setFacList] = useState([]);
  const [selectedFac, setSelectedFac] = useState(0);
  const [drugList, setDrugsList] = useState([]);
  const [getQtyRec, setQtyRec] = useState([]);
  const [showAll, setShowAll] = useState(true);
  const [disable, setDisable] = React.useState(false);
  const [qtyErrors, setQtyErrors] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const { register, setValue } = useForm({});
  const CustomCell = ({
    column,
    rowKeyValue,
    dispatch,
    value,
    rowData,
    ...rest
  }) => {
    return (
      <div>
        <span className="inline-block w-[91px] text-center">
          <input
            type="number"
            min="1"
            autoComplete="off"
            id={"qty" + rowData.id}
            name="qty"
            defaultValue={value}
            placeholder="Quantity"
            onBlur={(e) => {
              const inputValue = e.currentTarget.value;
              const qtyLimit = rowData.qty_limit > 0 ? Number(rowData.qty_limit) : null;
              dispatch(updateCellValue(rowKeyValue, column.key, inputValue));

              
              if (inputValue === "" || inputValue === null) {
                setQtyErrors((prev) => {
                  const next = { ...prev };
                  delete next[rowData.id];
                  return next;
                });
                setQtyRec((prev) => prev.filter((r) => r.id !== rowData.id));
                return;
              }

              const val = Number(inputValue);
              if (val <= 0) {
                setQtyErrors((prev) => ({
                  ...prev,
                  [rowData.id]: "Quantity must be at least 1",
                }));
              } else if (qtyLimit && val > qtyLimit) {
                setQtyErrors((prev) => ({
                  ...prev,
                  [rowData.id]: `Quantity exceeds the allowed limit of ${qtyLimit}`,
                }));
              } else {
                setQtyErrors((prev) => {
                  const next = { ...prev };
                  delete next[rowData.id];
                  return next;
                });
                let idx = getQtyRec.findIndex((elem) => elem.id === rowData.id);
                if (idx > -1) {
                  setQtyRec((prev) =>
                    prev.map((r) => r.id === rowData.id ? { ...r, qnty: inputValue } : r)
                  );
                } else {
                  let idx1 = drugList.findIndex((elem) => elem.id === rowData.id);
                  setQtyRec((prev) => [...prev, { ...drugList[idx1], qnty: inputValue }]);
                }
              }
            }}
            className="border focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-full"
          />
          {qtyErrors[rowData.id] && (
            <span className="text-hlred text-xs mt-1 block">
              {qtyErrors[rowData.id]}
            </span>
          )}
        </span>
      </div>
    );
  };

  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [tableProps1, changeTableProps1] = useState(tablePropsInit1);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
  };
  const dispatch1 = async (action) => {
    changeTableProps1((prevState) => kaReducer(prevState, action));
  };
  const getExistFacs = async () => {
    try {
      setLoading(true);
      let resp = await facilityService.getFacilities();
      if (resp) {
        setFacList(resp);
        if (resp.length === 1) {
          setValue("facility", resp[0].id);
          getExistingDrugs(resp[0].id);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  const getCategories = async () => {
    try {
      let resp = await stockService.getCategories();
      if (resp) {
        setCategoryList(resp);
      }
    } catch (e) {}
  };
  async function getExistingDrugs(facility) {
    if (facility > 0) {
      try {
        setLoading(true);
        setQtyRec([]);
        setSelectedCategory("");
        let resp = await stockService.getMasterDrugList("", facility);
        if (resp?.drugs?.length > 0) {
          if (resp.doctors?.length > 0) {
            resp.drugs.sort((a, b) =>
              (a.display_name ? a.display_name : a.drg_name).localeCompare(
                b.display_name ? b.display_name : b.drg_name
              )
            );
            let finalResult = resp.drugs.map((e) => ({
              ...e,
              docId: resp.doctors[0].id,
              qnty: 0,
            }));
            setShowAll(true);
            setDrugsList(finalResult);
            dispatch(updateData(finalResult));
            setShowDrugList(true);
          } else {
            setDrugsList([]);
            dispatch(updateData([]));
            setShowDrugList(false);
            const { hide } = cogoToast.error(
              "Please ask pharmacy to assign doctor for this facility",
              {
                hideAfter: 15,
                onClick: () => {
                  hide();
                },
              }
            );
          }
        } else {
          setDrugsList([]);
          dispatch(updateData([]));
          setShowDrugList(false);
          const { hide } = cogoToast.error("No Records Found!", {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
        }
        setSelectedFac(facility);
        setLoading(false);
      } catch (e) {
        setShowDrugList(false);
        const { hide } = cogoToast.error(
          "Error retrieving Master Drugs List. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    } else {
      setShowDrugList(false);
    }
  }
  const applyCategoryFilter = (cat) => {
    setSelectedCategory(cat);
    const base = cat
      ? drugList.filter((d) => d.category === cat)
      : drugList;
    const merged = base.map((d) => {
      const typed = getQtyRec.find((r) => r.id === d.id);
      return typed ? { ...d, Actions: typed.qnty } : d;
    });
    dispatch(updateData(merged));
  };
  const CustomCell2 = ({
    column,
    rowKeyValue,
    dispatch,
    value,
    rowData,
    ...rest
  }) => {
    let strngth = rowData.strength ? "-" + rowData.strength : "";
    let dosId = rowData.dos_id ? "-" + rowData.dos_id : "";
    return (
      <div>
        <span className="inline-block">
          {rowData.display_name
            ? rowData.display_name
            : rowData.drg_name + strngth + dosId}
        </span>
      </div>
    );
  };
  const CustomCellDescription = ({ rowData }) => (
    <div>
      <span className="inline-block text-xs">
        {rowData.description || "—"}
      </span>
    </div>
  );
  const CustomCellCategory = ({ rowData }) => (
    <div>
      <span className="inline-block text-xs">
        {rowData.category || "\u2014"}
      </span>
    </div>
  );
  const CustomCellQtyLimit = ({ rowData }) => (
    <div>
      <span className="inline-block text-xs">
        {rowData.qty_limit > 0 ? rowData.qty_limit : "\u2014"}
      </span>
    </div>
  );
  const CustomCellLastOrderDate = ({ rowData }) => (
    <div>
      <span className="inline-block text-xs">{rowData.last_order_date || "—"}</span>
    </div>
  );
  const CustomCellLastOrderQty = ({ rowData }) => (
    <div>
      <span className="inline-block text-xs">{rowData.last_order_qty ?? "\u2014"}</span>
    </div>
  );
  async function cancelSelection() {
    setShowAll(true);
  }
  async function submitQty() {
    let subRec = [];
    if (getQtyRec.length > 0) {
      getQtyRec.map((rec, i) => {
        subRec.push({
          stock_id: rec.id,
          fac_id: selectedFac,
          quantity: rec.qnty,
          doc_id: rec.docId,
        });
        return true;
      });
    }
    if (subRec.length > 0) {
      try {
        setLoading(true);
        let resp = await stockService.saveQuantity(subRec);
        if (resp) {
          const { hide } = cogoToast.success(
            "Stock Order(s) Placed Successfully!",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        } else {
          const { hide } = cogoToast.error(
            "Error while adding...Please try after sometime.",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        }
        setLoading(false);
        await history.push("/flStockReports");
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error while inserting quantity for drugs. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    }
  }
  async function saveQty() {
    if (Object.keys(qtyErrors).length > 0) {
      const { hide } = cogoToast.error(
        "Please fix the quantity limit errors before saving.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      return;
    }
    let saveRecords = getQtyRec.filter((res) => res.qnty > 0);
    if (saveRecords.length > 0) {
      setQtyRec(saveRecords);
      dispatch1(updateData(saveRecords));
      setShowAll(false);
    } else {
      const { hide } = cogoToast.error(
        "Please add quantity for atleast one drug .",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  }
  useEffect(() => {
    getExistFacs();
    getCategories();
  }, []);
  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000}
        />
      </div>
      <div className="bg-white w-10/12  mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 w=full">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl"> FL STOCK ORDERS </span>
          </div>
        </div>
        <div className="px-12 py-5">
          <ul className="">
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">Facility</label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="facility"
                aria-label="Select Facility"
                ref={register({
                  required: false,
                })}
                onChange={(e) => {
                  getExistingDrugs(e.target.value);
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="0">Select Facility</option>
                {facList
                  ? facList.map((facility, i) => {
                      return (
                        <option key={i} value={facility.id}>
                          {facility.name}
                        </option>
                      );
                    })
                  : null}
              </select>
              <p className="mt-4 inline-block font-base">
                <span className="text-hlred ">Note : </span>
                The Provider defaulting for the stock order is the main
                provider. If stock is ordered by other provider, please select
                the provider from the dropdown next to the order.
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div
        className={`bg-white w-10/12 mx-auto mt-2 mb-4 ${
          showDrugList ? "show" : "hidden"
        }`}
      >
        <div
          className={`text-xs  ${
            showAll ? "show" : "hidden"
          }`}
        >
          <div className="w-full flex flex-wrap justify-end items-center gap-3 mt-3 pr-1">
            <select
              aria-label="Filter by Category"
              value={selectedCategory}
              onChange={(e) => applyCategoryFilter(e.target.value)}
              className="border rounded h-10 px-2 text-sm font-light focus:outline-none focus:none align-bottom"
            >
              <option value="">All Categories</option>
              {categoryList
                ? categoryList.map((cat, i) => (
                    <option key={i} value={cat}>
                      {cat}
                    </option>
                  ))
                : null}
            </select>
            <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded h-10 w-72 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4 right-3 top-3"
              ></img>
            </span>
          </div>
          <div className="p-2 text-xs gridList overflow-x-auto">
            <Table
              {...tableProps}
              childComponents={{
                cellText: {
                  content: (props) => {
                    // eslint-disable-next-line default-case
                    switch (props.column.key) {
                      case "drg_name":
                        return <CustomCell2 {...props} />;
                      case "Description":
                        return <CustomCellDescription {...props} />;
                      case "Actions":
                        return <CustomCell {...props} />;
                      case "category":
                        return <CustomCellCategory {...props} />;
                      case "LastOrderDate":
                        return <CustomCellLastOrderDate {...props} />;
                      case "LastOrderQty":
                        return <CustomCellLastOrderQty {...props} />;
                    }
                  },
                },
              }}
              dispatch={dispatch}
            />
            <div className="w-full inline-block">
              <input
                type="button"
                onClick={() => {
                  saveQty();
                }}
                value="Save"
                className=" bg-header_bg rounded py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6
                float-right mr-1"
              />
            </div>
          </div>
        </div>
        <div
          className={`pb-5 text-xs selectedStkList gridList ${
            showAll ? "hidden" : "show"
          }`}
        >
          <div className="p-2 text-xs gridList overflow-x-auto">
          <Table
            {...tableProps1}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "drg_name":
                      return <CustomCell2 {...props} />;
                    case "Description":
                      return (
                        <span className="inline-block text-xs">
                          {props.rowData.description || "\u2014"}
                        </span>
                      );
                    case "category":
                      return <CustomCellCategory {...props} />;
                    case "LastOrderDate":
                      return <CustomCellLastOrderDate {...props} />;
                    case "LastOrderQty":
                      return <CustomCellLastOrderQty {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatch1}
          />
          </div>
          <div className="w-full mb-2 inline-block">
            <input
              type="button"
              onClick={() => {
                cancelSelection();
              }}
              value="Cancel"
              className="text-white w-full sm:w-auto h-8 px-6
              bg-header_bg rounded text-xs font-medium capitalize
              focus:outline-none float-right inline-block mr-4"
            />
            <input
              type="button"
              onClick={() => {
                if (Object.keys(qtyErrors).length > 0) {
                  const { hide } = cogoToast.error(
                    "Please fix the quantity limit errors before saving.",
                    {
                      hideAfter: 15,
                      onClick: () => {
                        hide();
                      },
                    }
                  );
                  return;
                }
                setDisable(true);
                submitQty();
              }}
              disabled={disable}
              value="Submit"
              className={`text-white w-full sm:w-auto h-8 px-6
              bg-header_bg rounded text-xs font-medium capitalize
              focus:outline-none float-right inline-block mr-4 ${
                disable ? "cursor-not-allowed" : ""
              }`}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(FLStockOrder)
);